import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Text } from '@app/design-system';
import { useThemeColors, useThemeAccent } from '@app/core';
import { BlockMetadata } from '../../types/builder';
import { useWebsiteBuilder } from '../../store/websiteBuilderStore';

interface Props {
  metadata: BlockMetadata;
}

export const BlockCard: React.FC<Props> = ({ metadata }) => {
  const themeColors = useThemeColors();
  const accentColor = useThemeAccent();
  const { addBlock, config } = useWebsiteBuilder();

  const handleAddBlock = () => {
    const newBlock = {
      id: `${metadata.type}-${Date.now()}`,
      type: metadata.type,
      order: config?.blocks.length || 0,
      enabled: true,
      visible: true,
      requiredPlan: metadata.requiredPlan,
      config: { ...metadata.defaultConfig },
    };

    addBlock(newBlock, config?.blocks.length || 0);
  };

  const getPlanBadgeColor = () => {
    switch (metadata.requiredPlan) {
      case 'FREE':
        return '#34C759';
      case 'BASIC':
        return '#007AFF';
      case 'PRO':
        return '#FF9500';
      case 'PREMIUM':
        return '#FF3B30';
      default:
        return themeColors.border || "#E5E5E5";
    }
  };

  const styles = StyleSheet.create({
    card: {
      backgroundColor: themeColors.secondary,
      borderWidth: 1,
      borderColor: themeColors.border || "#E5E5E5",
      borderRadius: 8,
      padding: 12,
      marginBottom: 12,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 8,
    },
    icon: {
      fontSize: 24,
      marginRight: 8,
    },
    name: {
      fontSize: 14,
      fontWeight: '600',
      color: themeColors.text || "#000000",
      flex: 1,
    },
    planBadge: {
      paddingHorizontal: 8,
      paddingVertical: 4,
      borderRadius: 12,
      backgroundColor: getPlanBadgeColor(),
    },
    planText: {
      fontSize: 10,
      fontWeight: '700',
      color: '#FFFFFF',
    },
    description: {
      fontSize: 12,
      color: themeColors.text || "#666666",
      marginBottom: 8,
    },
    addButton: {
      backgroundColor: accentColor,
      paddingVertical: 8,
      paddingHorizontal: 12,
      borderRadius: 6,
      alignItems: 'center',
    },
    addButtonText: {
      color: '#FFFFFF',
      fontSize: 12,
      fontWeight: '600',
    },
  });

  return (
    <View style={styles.card}>
      <View style={styles.header}>
        <Text style={styles.icon}>{metadata.icon}</Text>
        <Text style={styles.name}>{metadata.name}</Text>
        <View style={styles.planBadge}>
          <Text style={styles.planText}>{metadata.requiredPlan}</Text>
        </View>
      </View>

      <Text style={styles.description}>{metadata.description}</Text>

      <TouchableOpacity style={styles.addButton} onPress={handleAddBlock}>
        <Text style={styles.addButtonText}>+ Add Block</Text>
      </TouchableOpacity>
    </View>
  );
};

